"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lang_1 = __importDefault(require("../../../lang"));
const __1 = __importDefault(require("../.."));
function phoneNumber({ allowInternational } = { allowInternational: false }) {
    if (allowInternational) {
        throw new __1.default.ValidationError('International numbers not yet supported');
    }
    return this
        .matches(/^\d{3}-\d{3}-\d{4}$/, (0, lang_1.default)().validation.phoneNumberUs);
}
exports.default = phoneNumber;
